import React from "react";
import { HomeScreenContainer } from "src/containers";

export const HomeScreen = () => {
  return <HomeScreenContainer />;
};
